import { Sparkle } from "lucide-react";

export const Marquee = ({ items, dark = false }) => (
    <div
        data-testid="editorial-marquee"
        className={`overflow-hidden whitespace-nowrap border-y ${
            dark ? "border-white/10 bg-[#0A192F] text-white/80" : "border-slate-200 bg-white text-slate-500"
        } py-4 select-none`}
        aria-hidden="true"
    >
        <div className="animate-marquee inline-flex items-center">
            {[0, 1].map((dup) => (
                <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
                    {items.map((item, i) => (
                        <span key={i} className="flex items-center">
                            <span className="font-display italic text-lg sm:text-xl tracking-wide mx-8">{item}</span>
                            <Sparkle className={`h-3.5 w-3.5 ${dark ? "text-sky-400" : "text-blue-600"}`} />
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
